import 'daterangepicker'

export default class AutoScoutSetting {
  ready() {
    this.addTimepicker('#automatic_scout_setting_reserved_scout_time');
    this.scrollToAlertBottom();
    this.isShowOrHideButtonConfirm();
  }

  collapseConditionContent(target) {
    let textBox = $(target).siblings('.text-collapse');
    if ($(target).hasClass('caret-down')) {
      $(target).addClass('caret-up').removeClass('caret-down');
      textBox.addClass('unclamp').removeClass('clamp');
    } else {
      $(target).addClass('caret-down').removeClass('caret-up');
      textBox.addClass('clamp').removeClass('unclamp');
    }
  }

  scrollToAlertBottom() {
    let alertMessage = $('#alert-bottom');
    if (alertMessage.length > 0) {
      $('html, body').animate({
        scrollTop: alertMessage.offset().top
      }, 1000);
    }
  }

  clearResendIntervalRadio(target) {
    $(target).siblings('.radio').find('input[type=radio]').prop('checked', false);
  }

  changeStatusRadio(target){
    let form = $(target).closest("#new_automatic_scout_setting")
    let jaResendSelected = 'automatic_scout_setting_ja_message_template_resend_id'
    let enResendSelected = 'automatic_scout_setting_en_message_template_resend_id'
    let button = form.find('a.js-disable')
    let radio = form.find('input[type="radio"]')
    if($(`#${jaResendSelected}`).val() !== "" || $(`#${enResendSelected}`).val() !== ""){
      radio.removeAttr('disabled')
      button.attr('onclick', 'AutoScoutSetting.clearResendIntervalRadio(this)').removeClass('btn-clear-disable');
    }
    else{
      radio.prop('checked', false).attr('disabled', true);
      button.addClass('btn-clear-disable').removeAttr('onclick');
    }
  }

  addTimepicker(elm) {
    $(elm).timepicker({
      template: 'dropdown',
      minuteStep: 15,
      showInputs: false,
      disableFocus: true,
      showMeridian: false,
      icons: {
        up: 'fa fa-chevron-up',
        down: 'fa fa-chevron-down'
      }
    });
  }

  toggleMeetingUrl(label, target) {
    let mtgUrlWrapper = $(target).closest('.meeting-url-wrapper');
    if ($(label).find('input').is(':checked')) {
      mtgUrlWrapper.removeClass('d-none');
    } else {
      mtgUrlWrapper.addClass('d-none');
    }
  }

  toggleSection(label, target) {
    let targetId = /^#/.test(target) ? target : `#${target}`;

    let section = $(targetId);
    let input = $(label).find('input:checked');
    let btnShowDetailSetting = $('.js-show-auto-scout-setting');

    section && input.length > 0 ? section.show() : section.hide();

    if (input.length === 0) {
      btnShowDetailSetting.addClass('d-flex');
      btnShowDetailSetting.removeClass('d-none');
    } else {
      btnShowDetailSetting.addClass('d-none');
      btnShowDetailSetting.removeClass('d-flex');
    }

    btnShowDetailSetting.find('button').removeClass('open');
    this.isShowOrHideButtonConfirm();
  }

  showDetailSetting(btn, target) {
    let targetId = /^#/.test(target) ? target : `#${target}`;
    let btnElem = $(btn);
    let section = $(targetId);
    section.toggle();
    btnElem.hasClass('open') ? btnElem.removeClass('open') : btnElem.addClass('open');
  }

  saveORDraft(target, saveType) {
    let modalConfirm = $(target).parents('#automatic-scout-confirmation');
    let form = modalConfirm.siblings('form.new_automatic_scout_setting');
    if (saveType === 'on-save') {
      form.submit();
    } else if (saveType === 'on-draft') {
      let hiddenField = $('<input>').attr('type', 'hidden').attr('name', 'draft').val(true);
      form.append(hiddenField);
      form.submit();
    }
    modalConfirm.modal('hide');
  }

  onCloseOrRedirectWindow(path) {
    if (window.history.length === 1 || (window.opener && window.opener !== window)) {
      window.opener.location.reload(true)
      window.close()
    } else {
      window.location.replace(path)
    }
  }

  isShowOrHideButtonConfirm() {
    $(document).ready(() => {
      let autoScoutOn = $('[name="is_active"]:checked');
      let enabledNoticeFlag = $('input.notify-limit-setting-checkbox[name="automatic_scout_setting[enabled_notice_flag]"]');

      if (autoScoutOn.length > 0) {
        $('.btn-save-auto-scout').addClass('d-none');
        $('.btn-confirm-auto-scout').removeClass('d-none');
        if (enabledNoticeFlag.data('is-auto') == 'off') enabledNoticeFlag.prop('checked', true);
      } else {
        $('.btn-save-auto-scout').removeClass('d-none');
        $('.btn-confirm-auto-scout').addClass('d-none');
        if (enabledNoticeFlag.data('is-auto') == 'on') enabledNoticeFlag.data('is-auto', 'off');
      }
    });
  }
}
